/*
 * @Description: 
 * @Author:  
 * @Date: 2024-07-24 09:27:31
 * @LastEditTime: 2024-09-04 15:29:05
 * @LastEditors:  
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Cookies from 'js-cookie'
import { Arefreshlogin, Agetmeta, Ainsertrecords } from '@/service/app'
import { getActExhibitionDetailInfo, getMainPageContent, getChannelById } from '@/service/vbef'
import { getLocalShareChannelId, setLocalShareChannelId } from 'js/shareChannel'
import moment from 'moment'
import { creatuuid } from '@/assets/js/uuid'

// 检查是否是移动设备
const userAgent = navigator.userAgent;
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

const home = () => !isMobile ? import('./views/homePC') : import('./views/homeMobile')
const index = () => !isMobile ? import('./views/index/indexPC') : import('./views/index/indexMobile')
const error404 = () => !isMobile ? import('./views/error/error404PC') : import('./views/error/error404Mobile')
const qa = () => !isMobile ? import('./views/qa/qaPC') : import('./views/qa/qaMobile')
const signUp = () => !isMobile ? import('./views/signUp/signUpPC') : import('./views/signUp/signUpMobile')
const asgct = () => !isMobile ? import('./views/asgct/asgctPC') : import('./views/asgct/asgctMobile')
const userInfo = () => !isMobile ? import('./views/user/userInfoPC') : import('./views/user/userInfoMobile')
const myTickets = () => !isMobile ? import('./views/myTickets/myTicketsPC') : import('./views/myTickets/myTicketsMobile')
const guests = () => !isMobile ? import('./views/guest/guestPC.vue') : import('./views/guest/guestMobile.vue')
const guestInfo = () => !isMobile ? import('./views/guest/guestInfoPC') : import('./views/guest/guestInfoMobile')

const orderList = () => !isMobile ? import('./views/orderList/orderListPC') : import('./views/orderList/orderListMobile')
const ticketDetail = () => !isMobile ? import('./views/ticketDetail/ticketDetailPC') : import('./views/ticketDetail/ticketDetailMobile')

const exhibitionDesc = () => !isMobile ? import('./views/exhibition/exhibitionDescPC') : import('./views/exhibition/exhibitionDescMobile')
const exhibitors = () => !isMobile ? import('./views/exhibitors/exhibitorsPC') : import('./views/exhibitors/exhibitorsMobile')
const newsList = () => !isMobile ? import('./views/newsList/newsListPC') : import('./views/newsList/newsListMobile')
const compReg = () => !isMobile ? import('./views/compReg/compRegPC') : import('./views/compReg/compRegMobile')
const contactUs = () => !isMobile ? import('./views/contactUs/contactUsPC') : import('./views/contactUs/contactUsMobile')

const agenda = () => !isMobile ? import('./views/agenda/agendaPc') : import('./views/agenda/agendaMobile')
const theme = () => !isMobile ? import('./views/theme/themePc') : import('./views/theme/themeMobile')
const previousTheme = () => !isMobile ? import('./views/previous/themePc') : import('./views/previous/themeMobile')
const companions = () => !isMobile ? import('./views/companions/companionsPc') : import('./views/companions/companionsMobile')
const addCompanions = () => !isMobile ? import('./views/companions/addCompanionsPC') : import('./views/companions/addCompanionsMobile')

const createShare = () => !isMobile ? import('./views/error/error404PC') : import('./views/createShare/createShareMobile')
const newsDetail = () => !isMobile ? import('./views/newsDetail/newsDetailPC') : import('./views/newsDetail/newsDetailMobile')
const paySuccess = () => import('./views/pay/success')
const cancel = () => import('./views/cancel/cancel')
const callback = () => import('./views/callback')


Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '',
  routes: [
    { path: '/cancel', name: 'cancel', meta: { route_name: '门票核销', enter_type: 167, view_content_type: 167 }, component: cancel },
    { path: '/callback/:mode', name: 'callback', meta: { route_name: '登录回调', enter_type: 170, view_content_type: 170 }, component: callback },
    {
      path: '/',
      name: 'home',
      component: home,
      children: [
        { path: '/', name: 'index', meta: { route_name: '首页', enter_type: 146, view_content_type: 146 }, component: index },
        { path: 'qa', name: 'qa', meta: { route_name: '常见问题', enter_type: 147, view_content_type: 147 }, component: qa },
        { path: 'signUp', name: 'signUp', meta: { route_name: '报名参会', enter_type: 148, view_content_type: 148 }, component: signUp },
        { path: 'asgct', name: 'asgct', meta: { route_name: '报名参会', enter_type: 148, view_content_type: 148 }, component: asgct },
        { path: 'userInfo', name: 'userInfo', meta: { route_name: '个人信息', enter_type: 149, view_content_type: 149 }, component: userInfo },
        { path: 'myTickets', name: 'myTickets', meta: { route_name: '我的门票', enter_type: 150, view_content_type: 150 }, component: myTickets },
        { path: 'guests', name: 'guests', meta: { route_name: '嘉宾列表', enter_type: 151, view_content_type: 151 }, component: guests },
        { path: 'guestInfo/:id', name: 'guestInfo', meta: { route_name: '嘉宾详情', enter_type: 152, view_content_type: 152 }, component: guestInfo },
        { path: 'orderList', name: 'orderList', meta: { route_name: '我的订单', enter_type: 153, view_content_type: 153 }, component: orderList },
        { path: 'exhibitors', name: 'exhibitors', meta: { route_name: '展商列表', enter_type: 154, view_content_type: 154 }, component: exhibitors },
        { path: 'newsList', name: 'newsList', meta: { route_name: '新闻资讯', enter_type: 155, view_content_type: 155 }, component: newsList },
        { path: 'compReg', name: 'compReg', meta: { route_name: '参展申请', enter_type: 156, view_content_type: 156 }, component: compReg },
        { path: 'contactUs', name: 'contactUs', meta: { route_name: '联系客服', enter_type: 157, view_content_type: 157 }, component: contactUs },
        { path: 'ticketDetail/:id', name: 'ticketDetail', meta: { route_name: '获取门票', enter_type: 158, view_content_type: 158 }, component: ticketDetail },
        { path: 'exhibitionDesc/:id', name: 'exhibitionDesc', meta: { route_name: '内容详情', enter_type: 159, view_content_type: 159 }, component: exhibitionDesc },
        { path: 'agenda', name: 'agenda', meta: { route_name: '会议议程', enter_type: 165, view_content_type: 165 }, component: agenda },
        { path: 'companions', name: 'companions', meta: { route_name: '我的同行人', enter_type: 166, view_content_type: 166 }, component: companions },
        { path: 'addCompanions', name: 'addCompanions', meta: { route_name: '添加同行人', enter_type: 163, view_content_type: 163 }, component: addCompanions },
        { path: 'createShare', name: 'createShare', meta: { route_name: '获取分享二维码', enter_type: 164, view_content_type: 164 }, component: createShare },
        { path: 'newsDetail/:id', name: 'newsDetail', meta: { route_name: '文章详情', enter_type: 168, view_content_type: 168 }, component: newsDetail },
        { path: 'theme', name: 'theme', meta: { route_name: '大会日程', enter_type: 169, view_content_type: 169 }, component: theme },
        { path: 'previousTheme', name: 'previousTheme', meta: { route_name: '2025CSGCT大会日程', enter_type: 170, view_content_type: 170 }, component: previousTheme },
        { path: 'paySuccess', name: 'paySuccess', meta: { route_name: '支付成功', enter_type: 146, view_content_type: 146 }, component: paySuccess },

        { path: '*', name: 'error404', meta: { route_name: '404', enter_type: 160, view_content_type: 160 }, component: error404 },
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  let cookies_uuid = Cookies.get('uuid')
  if (cookies_uuid && cookies_uuid != null) {
    store.commit('setUUid', cookies_uuid)
  } else {
    let u = creatuuid()
    Cookies.set('uuid', u, { domain: store.state.domain_path, path: '/' })
    store.commit('setUUid', u)
  }

  const sharechannel = to.query.sharechannel
  if (sharechannel) {
    setLocalShareChannelId(sharechannel)
  }

  const asgctchannel = to.query.asgctchannel
  if (asgctchannel) {
    setLocalShareChannelId(asgctchannel, 'asgctchannel')
  }

  /**
   * 元数据
   */
  if (store.state.firstLoad) {
    let app_meta_res = await Agetmeta({
      metaNameList: ['appMobileAreaCodeDtos'],
    })
    if (app_meta_res.code == 0) {
      store.commit('updateDict', {
        appMobileAreaCodeDtos: app_meta_res.data.appMobileAreaCodeDtos
      })
    }
    // let vbef_meta_res = await getMeta({
    //   metaNameList: ['chinaAddressList'],
    // })
    // if (vbef_meta_res.code == 0) {
    //   store.commit('updateDict', {
    //     chinaAddressList: vbef_meta_res.data.chinaAddressList
    //   })
    // }
    if (to.name != 'cancel') {
      let main_res = await getMainPageContent({
        activityId: store.state.activityId,
      })
      if (main_res.code == 0) {
        store.commit('updateMainPageContent', main_res.data.mainPageContentRelationDtos || [])
      }
      store.commit('setFirstLoad', 0)
    }
  }
  if (!store.state.user_key || ['signUp', 'userInfo'].includes(to.name)) {
    let cookies_user_key = Cookies.get('user_key_' + store.state.cookie_type)
    if (cookies_user_key) {
      let refresh_res = await Arefreshlogin({ user_key: cookies_user_key })
      if (refresh_res.code == 0) {
        store.commit('updateUserKey', cookies_user_key)
        store.commit('updateUser', refresh_res.data)
        store.commit('setUUserId', refresh_res.data.id)
      } else {
        store.commit('updateUserKey', '')
        store.commit('updateUser', '')
        store.commit('setUUserId', '')
      }
    }
  }
  if (!to.query.language) {
    if (from.query.language) {
      store.commit('setLanguage', from.query.language)
      next({ path: to.path, hash: to.hash, query: { ...to.query, language: from.query.language } });
    } else {
      next()
    }
  } else {
    store.commit('setLanguage', to.query.language)
    next();
  }

  if (!store.state.activityDetail.id && to.name != 'cancel') {
    let activity_res = await getActExhibitionDetailInfo({
      actId: store.state.activityId,
    })
    if (activity_res.code == 0) {
      store.commit('updateActivity', activity_res.data.actExhibitionDto)
    }
  }

  const shareChannelId = getLocalShareChannelId()
  if (shareChannelId && to.name == 'signUp') {
    let res = await getChannelById({
      actId: store.state.activityId,
      channelId: store.state.language == 'zh' && shareChannelId == 203 ? 204 : shareChannelId,
    })
    if (res.code === 0) {
      store.commit('setShareChannel', res.data)
    }
  }

  const asgctChannelId = getLocalShareChannelId('asgctchannel')
  if (asgctChannelId && to.name == 'asgct') {
    let res = await getChannelById({
      actId: 1127,
      channelId: asgctChannelId,
    })
    if (res.code === 0) {
      store.commit('setAsgctChannel', res.data)
    }
  }

  /**
   * 浏览记录 
   */
  let contentId = to.params.id || store.state.activityId
  let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
  let records_res = await Ainsertrecords({
    appAccessRecords: [{
      contentId: contentId,
      contentType: to.meta.view_content_type,
      viewType: 2,
      createTime: createTime,
      xuserid: store.state.uuserId,
      imei: store.state.uuid,
      enterType: to.meta.enter_type,
      loginPlatform: store.state.isMobile ? 9 : 8,
    }]
  })
})

export default router
